import React, { useState, useEffect } from 'react';
import { HiOutlineBell, HiXMark } from 'react-icons/hi2';
import './GlobalNotification.css';

const GlobalNotification = ({ isAuthenticated }) => {
  const [notification, setNotification] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [notifType, setNotifType] = useState('OUTER');

  useEffect(() => {
    // Function to check for new notifications
    const checkForNotification = () => {
      const now = new Date().getTime();
      
      const checkNotif = (storageKey) => {
        const saved = localStorage.getItem(storageKey);
        if (saved) {
          try {
            const data = JSON.parse(saved);
            const dismissed = localStorage.getItem(`dismissed_notif_${data.id}`);
            const expiryTime = data.expiry || (data.timestamp + 86400000);
            
            if (now < expiryTime && !dismissed) {
              return data;
            }
          } catch (e) {
            console.error('Error parsing notification', e);
          }
        }
        return null;
      };

      // 1. Check Outer (Global) Notification
      const outerNotif = checkNotif('stocks4u_outer_notification');
      if (outerNotif) {
        setNotification(outerNotif);
        setNotifType('OUTER');
        setIsVisible(true);
        return;
      }

      // 2. Check Inner Notification (Requires Login)
      if (isAuthenticated) {
        const innerNotif = checkNotif('stocks4u_inner_notification');
        if (innerNotif) {
          setNotification(innerNotif);
          setNotifType('INNER');
          setIsVisible(true);
          return;
        }
      }

      // 3. Fallback (Current backward compatibility just in case)
      const globalNotif = checkNotif('stocks4u_global_notification');
      if (globalNotif) {
        setNotification(globalNotif);
        setNotifType('GLOBAL');
        setIsVisible(true);
        return;
      }

      setNotification(null);
      setIsVisible(false);
    };

    // Initial check
    checkForNotification();

    // Listen for storage changes (works across tabs)
    const handleStorageChange = (e) => {
      if (
        e.key === 'stocks4u_outer_notification' ||
        e.key === 'stocks4u_inner_notification' ||
        e.key === 'stocks4u_global_notification' ||
        e.key === 'user' ||
        e.key?.startsWith('dismissed_notif_')
      ) {
        checkForNotification();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    
    // Check every few seconds for local tab changes
    const interval = setInterval(checkForNotification, 3000);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, [isAuthenticated]);

  const handleDismiss = () => {
    setIsVisible(false);
    if (notification) {
      localStorage.setItem(`dismissed_notif_${notification.id}`, 'true');
    }
  };

  if (!isVisible || !notification) return null;

  return (
    <div className="global-notif-wrapper">
      <div className="global-notif-card">
        <div className="notif-icon-pulse">
          <HiOutlineBell />
        </div>
        <div className="notif-content">
          <div className="notif-header">
            <span className="notif-badge">{notifType === 'INNER' ? 'INNER BROADCAST' : 'GLOBAL BROADCAST'}</span>
            <span className="notif-time">Just now</span>
          </div>
          <p className="notif-message">{notification.message}</p>
        </div>
        <button className="notif-close-btn" onClick={handleDismiss}>
          <HiXMark />
        </button>
      </div>
    </div>
  );
};

export default GlobalNotification;
